import React, { useState } from 'react';
import { Tabs } from 'antd';
import { GlobalOutlined, FileTextOutlined } from '@ant-design/icons';
import AllWebsites from './AllWebsites';
import ActivityLogs from './ActivityLogs';
import '../super-admin.css';

const WebsitesManagement = () => {
  const [activeTab, setActiveTab] = useState('all');

  const items = [
    {
      key: 'all',
      label: (
        <span>
          <GlobalOutlined />
          All Websites
        </span>
      ),
      children: <AllWebsites />,
    },
    {
      key: 'logs',
      label: (
        <span>
          <FileTextOutlined />
          Activity Logs
        </span>
      ),
      children: <ActivityLogs />,
    },
  ];

  return (
    <div className="sa-content">
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        size="large"
        style={{ marginBottom: 24 }}
      />
    </div>
  );
};

export default WebsitesManagement;
